import { render } from "./ShowCongPonen.vue?vue&type=template&id=144199ca&scoped=true"
import script from "./ShowCongPonen.vue?vue&type=script&lang=js"
export * from "./ShowCongPonen.vue?vue&type=script&lang=js"

import "./ShowCongPonen.vue?vue&type=style&index=0&id=144199ca&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-144199ca"

export default script